import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class InvoiceExpensesClassificationType  {
    _originalTypeClassName = "zERP.BO.InvoiceExpensesClassificationType";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
InvoiceExpensesClassificationType.translate = translateService;
}
this.id = null;
this.InvoiceMark = null;
this.ClassificationMark = null;
this.ClassificationMarkSpecified = false;
this._key = this.id = 0; 
}

static translate: TranslateService;
_key: any;
private _id:any;
get id(): any {
    return this._id;
  }
set id(value: any) {
    this._id = value;
    this._key = value;
  }
InvoiceMark:any;
ClassificationMark:any;
ClassificationMarkSpecified:any;


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.id == null || $this.id == 0;
            }


}